// extracted by mini-css-extract-plugin
export default {"button":"AuthModal_button__0FyV3"};